import { trackEvent } from './../../../utils/index';
import { isArray, isObject } from 'lodash-es';

interface IAsyncSubmitEvent {
  type: string;
  is_success: string;
  campaign_fail: string;
  adgroup_fail: string;
  ad_fail: string;
}

const DEFAULT_EVENT_PARAM: IAsyncSubmitEvent = {
  type: 'create',
  is_success: 'false',
  campaign_fail: 'false',
  adgroup_fail: 'false',
  ad_fail: 'false',
};

/** 异步创建结果上报 */
export const trackEventAsyncSubmit = (params: Partial<IAsyncSubmitEvent>) => {
  trackEvent('ttam_creation_async_submit', Object.assign({}, DEFAULT_EVENT_PARAM, params));
};

/** 异步创建耗时上报 */
export const trackEventAsyncSubmitDuration = (api: string, duration: number) => {
  trackEvent('ttam_creation_async_submit_duration', { api, duration });
};

/** 异步创建流程后上报adgroup、ad埋点【create_source】 */
export const trackEventAsyncSubmitAdgroupAndAdCreateSource = (result: Record<string, unknown>) => {
  // TODO: 基座应用并未提供批量上报埋点的封装，目前是并发上报，后续需要在基座中提供批量上报
  const { ad_and_creative = {}, campaign_id } = result || {};
  const adgroupList = Object.values(ad_and_creative);
  adgroupList.forEach(adgroup => {
    trackEvent('ttam_creation_async_submit_adgroup_create_source', {
      campaign_id,
      adgroup_id: adgroup.ad_id,
      snap_create_source: adgroup.snap_create_source,
    });
    if (isObject(adgroup.batch_result)) {
      Object.values(adgroup.batch_result).forEach((batch: any) => {
        if (isArray(batch.creative_items)) {
          batch.creative_items.forEach(creative_item => {
            trackEvent('ttam_creation_async_submit_ad_create_source', {
              campaign_id,
              ad_id: creative_item.id,
              snap_create_source: creative_item.snap_create_source,
              is_aco: 0,
            });
          });
        }
      });
    }
    if (isObject(adgroup.aco_result)) {
      trackEvent('ttam_creation_async_submit_ad_create_source', {
        campaign_id,
        ad_id: adgroup.ad_id,
        snap_create_source: adgroup.aco_result.snap_create_source,
        is_aco: 1,
      });
    }
  });
};
